import React from 'react';
import Html from 'react-pdf-html';

/**
 * Wrapper for react-pdf-html to add global configurations and preprocessing.
 */
export const PdfHtml = ({
  style,
  stylesheet,
  renderers,
  children,
  ...props
}) => {
  // Pre-process children to replace <ins> with <u> so react-pdf-html treats it as an inline element
  const processedChildren =
    typeof children === 'string'
      ? children.replace(/<ins/g, '<u').replace(/<\/ins>/g, '</u>')
      : children;

  const globalRenderers = {
    // Add other global renderers here...
    ...renderers // allow overriding locally
  };

  const globalStylesheet = {
    // Add global default stylesheets here
    a: { color: 'inherit', textDecoration: 'none' },
    li_content: {
      flexBasis: 'auto',
      flexGrow: 1
    },
    li: {
      marginTop: 16
    },
    ...stylesheet // allow overriding locally
  };

  return (
    <Html
      style={style}
      stylesheet={globalStylesheet}
      renderers={globalRenderers}
      {...props}
    >
      {processedChildren}
    </Html>
  );
};
